{
  "actions": "Действия",
  "actionsAvailable": "Возможно выполнение действий.",
  "clearSelection": "Очистить выбор",
  "selected": "Выбрано: {count}",
  "selectedAll": "Выбрано все"
}
